export interface IValidation {
    fullName: boolean,
    addressLine1: boolean,
    city: boolean,
    state: boolean,
    postalCode: boolean,
    email: boolean,
    phone: boolean,
    phone2: boolean
}